import axios from "axios";
import authHeader from "./services/auth.header";
import Swal from "sweetalert2";
import getBaseUrl from "./shared/getBaseUrl";

const instance = axios.create({
  baseURL: getBaseUrl(),
  headers: authHeader(),
});

instance.interceptors.request.use(
  (request) => {
    console.log(request);

    return request;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    console.log(response);
    if (
      (response.config.method === "post" || response.config.method === "put") &&
      response.config.url !== "/User/AuthenticateUser" &&
      response.config.url !== "/Alarm/GetAlarmsFromDeviceByAlarmGId" &&
      response.config.url !== "/User/VerifyUser"
    ) {
      if (response.status === 200) {
        if (
          response.config.url === "/Beneficiary/SensitiveData" ||
          response.config.url === "/Alarm/LastKnownLocation" ||
          response.config.url === "/Alarm/GetAlarmsFromDeviceByAlarmId" ||
          response.config.url === "/User/VerifyUser" ||
          response.config.url === "/Alarm/Locations"
        ) {
          return response;
        } else if (response.config.url.includes("/Address/IsAddressValid/9186")) {
          Swal.fire(
            "Παρακαλώ Επιβεβαιώστε τη διεύθυνση στο Χάρτη αλλιώς αν δεν ειναι σωστή προσπαθήστε ξανά",
            "",
            "info"
          );
        } else {
          Swal.fire(
            "Η καταχώρηση σας πραγματοποιήθηκε με επιτυχία",
            "",
            "success"
          );
        }
      }
    }
    return response;
  },
  (error) => {
    if (
      error.response?.status === 302 &&
      error.config.url === "/User/AuthenticateUser"
    ) {
      return error;
    }
    if (error.message === "Network Error") {
      Swal.fire("Αδυναμία σύνδεσης με τον Server", "", "error");
    } else if (
      error.response.config.url === "/User/VerifyUser" ||
      (error.response.config.url === "/User/AuthenticateUser" &&
        error.response.status !== 302)
    ) {
      Swal.fire("Λάθος στοιχεία σύνδεσης", "", "error");
    } else if (error.response.config.method !== "get") {
      Swal.fire("Η καταχώρηση ήταν ανεπιτυχής", "", "error");
    }
    return Promise.reject(error);
  }
);

export default instance;
